import EventEmitter from "events";
import { getRemoteConfigValue } from "src/modules/firebase/index";

function createFreemiumVideo() {
  const emitter = new EventEmitter();
  let videoDuration = getRemoteConfigValue("freemium_video_time");

  let _isRunning = false;
  let timeoutId = null;
  let freemiumVideoStartDate = null;
  let _reject = null;

  const fetchConfig = async () => {
    videoDuration = getRemoteConfigValue("freemium_video_time");
  };

  const clearFreeVideoTimeout = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };

  const getProgress = () => {
    const currentTime = Date.now() - freemiumVideoStartDate;
    return currentTime / videoDuration;
  };

  const start = async () => {
    _isRunning = true;
    emitter.emit("timer-start");
    freemiumVideoStartDate = Date.now();
    clearFreeVideoTimeout();

    return new Promise((resolve, reject) => {
      _reject = () => reject("cleared");
      timeoutId = setTimeout(() => {
        _isRunning = false;
        emitter.emit("timer-end");
        clearFreeVideoTimeout();
        resolve();
      }, videoDuration);
    });
  };

  const interrupt = () => {
    clearFreeVideoTimeout();
    _reject();
    _isRunning = false;
    emitter.emit("timer-end");
  };

  return {
    on: (...args) => emitter.on(...args),
    off: (...args) => emitter.off(...args),
    start,
    interrupt,
    getProgress,
    fetchConfig,
    get isRunning() {
      return _isRunning;
    }
  };
}

const FreemiumVideo = createFreemiumVideo();
export default FreemiumVideo;
